import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useHistory, useParams } from 'react-router-dom'
import { AppBar, Box, IconButton, Toolbar } from '@mui/material'

import { useStores } from '@trivie/core'
import { Button } from '@trivie/ui-web/components/button'
import { Text } from '@trivie/ui-web/components/text'
import { CardEditor } from '../../../components/document-editor/card-editor'
import { ArrowBack, Warning, Error } from '@mui/icons-material'
import { StatusBar } from '../../../components/question-form/status-bar'
import { color } from '@trivie/ui-web/theme/color'

export const CreateCardScreen: React.FunctionComponent = observer(() => {
  const { cardStore } = useStores()
  const { loadCards, cardNames, reset, selectedCard, createNewCard, createInfoCard, getInfoCard } =
    cardStore

  const { cardID } = useParams<any>()
  const history = useHistory()

  useEffect(() => {
    reset()
    loadCards()
    if (cardID) {
      getInfoCard(cardID)
    } else {
      createNewCard()
    }
  }, [])

  const publish = () => {
    if (selectedCard) {
      if (cardID) {
        selectedCard.update().then(() => {
          history.goBack()
        })
      } else {
        createInfoCard(selectedCard).then(() => {
          history.goBack()
        })
      }
    }
  }

  const getStatusMessage = () => {
    if (selectedCard?.allErrors && selectedCard?.allErrors.length > 0) {
      if (selectedCard?.allWarnings.length > 0) {
        return `${selectedCard?.allErrors.length} error${
          selectedCard?.allErrors.length > 1 ? 's' : ''
        } and ${selectedCard?.allWarnings.length} warning${selectedCard?.allWarnings.length > 1 ? 's' : ''}`
      } else if (selectedCard?.allWarnings.length === 0) {
        return `${selectedCard?.allErrors.length} error${selectedCard?.allErrors.length > 1 ? 's' : ''}`
      }
    } else if (selectedCard?.approved) {
      return `Approved`
    }
    return 'Approved'
  }

  if (!selectedCard) {
    return null
  }

  return (
    <>
      <Box sx={ROOT}>
        <AppBar
          sx={{ background: '#fff', boxShadow: '0px -1px 0px 0px #E2E2EA inset', borderRadius: 0 }}
          position="fixed"
        >
          <Toolbar sx={{ justifyContent: 'space-between' }}>
            <IconButton color="inherit" onClick={history.goBack}>
              <ArrowBack htmlColor="#000" />
            </IconButton>
            <Button
              disabled={selectedCard?.allErrors?.length > 0}
              text="Publish"
              variant="contained"
              color="primary"
              onClick={publish}
            />
          </Toolbar>
        </AppBar>
        <div style={{ paddingTop: 70, width: '100%', justifyContent: 'center', display: 'flex' }}>
          <div id="CardForm" style={CONTAINER}>
            {selectedCard?.touched && (
              <StatusBar
                expanded={Boolean(selectedCard?.showStatus)}
                handleExpandClick={() => selectedCard?.set('showStatus', !selectedCard?.showStatus)}
                expandable={Boolean(
                  ((selectedCard?.allErrors && selectedCard?.allErrors.length) ?? 0) +
                    ((selectedCard?.allWarnings && selectedCard?.allWarnings.length) ?? 0) >
                    0,
                )}
                message={getStatusMessage()}
                style={{ marginBottom: 12, alignSelf: 'center', width: '100%' }}
                type={selectedCard?.allErrors.length ? 'error' : 'success'}
              >
                {selectedCard?.allErrors.map((e: any) => {
                  return (
                    <div style={ISSUE}>
                      <Error style={{ fontSize: 14, marginRight: 12 }} htmlColor={color.red} />
                      <Text
                        style={{ color: color.shade80 }}
                        variant="body2Medium"
                        text={e.message}
                      />
                    </div>
                  )
                })}
                {selectedCard?.allWarnings.map((e: any) => {
                  return (
                    <div style={ISSUE}>
                      <Warning style={{ fontSize: 14, marginRight: 12 }} htmlColor={color.yellow} />
                      <Text
                        style={{ color: color.shade80 }}
                        variant="body2Medium"
                        text={e.message}
                      />
                    </div>
                  )
                })}
              </StatusBar>
            )}
            <CardEditor existing={cardNames} card={selectedCard} />
          </div>
        </div>
      </Box>
    </>
  )
})

const ROOT: React.CSSProperties = {
  width: '100%',
  display: 'flex',
  height: '100%',
  position: 'absolute',
  top: '0px',
  left: '0px',
  background: '#F4F4F4',
  justifyContent: 'center',
  padding: '40px',
}
const CONTAINER: React.CSSProperties = {
  width: '100%',
  height: '100%',
  overflowY: 'auto',
  display: 'flex',
  justifyContent: 'center',
  minWidth: 400,
  maxWidth: 600,
  flexDirection: 'column',
  borderRadius: 20,
  background: '#fff',
  padding: 20,
}
const ISSUE: React.CSSProperties = {
  flexDirection: 'row',
  display: 'flex',
  padding: 12,
  paddingLeft: 24,
}
